module.exports = __webpack_public_path__ + "static/media/fontello.28a56906.woff";